var _desc, _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIconShopBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Shopping basket icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A red and orange shopping basket matching the Hogcloud service icon colors.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basket-fill",
    x1: 16,
    y1: 30,
    x2: 80,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91011e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basket-handle",
    x1: 28,
    y1: 12,
    x2: 68,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b23212"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 43,
    fill: "#fff7f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 42.5c0-12.1 7.4-22 16.5-22s16.5 9.9 16.5 22",
    fill: "none",
    stroke: "url(#basket-handle)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 38h60l-7.4 39.2A8 8 0 0 1 62.8 84H33.2a8 8 0 0 1-7.8-6.8L18 38Z",
    fill: "url(#basket-fill)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h52",
    fill: "none",
    stroke: "#f6a33c",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v21M48 50v21M62 50v21",
    fill: "none",
    stroke: "#fff7f5",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.92
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 59h40",
    fill: "none",
    stroke: "#fff7f5",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.92
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h46l-.9 5H25.9L25 42Z",
    fill: "#6f0017",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIconShopBasket);
export default __webpack_public_path__ + "static/media/service-icon-shop-basket.ca7f5e0167f0e2c8c4c06d8e9f5db343.svg";
export { ForwardRef as ReactComponent };